<script type="ts">
	import { slide } from 'svelte/transition';
	const definitions = [
		{
			name: 'Wikipedia',
			source: 'https://en.wikipedia.org/wiki/Strategy_pattern',
			text: 'In computer programming, the strategy pattern (also known as the policy pattern) is a behavioral software design pattern that enables selecting an algorithm at runtime.'
		},
		{
			name: 'Refactoring Guru',
			source: 'https://refactoring.guru/design-patterns/strategy',
			text: 'Strategy is a behavioral design pattern that lets you define a family of algorithms, put each of them into a separate class, and make their objects interchangeable.'
		},
		{
			name: 'Design Patterns',
			source: 'https://www.gofpatterns.com/behavioral/patterns/strategy-pattern.php',
			text: 'The intent of the Strategy Pattern is to define a family of algorithms, encapsulate each algorithm, and make them interchangeable.'
		}
	];
	let isOpen = false;
</script>

<div class="definitions grid--inner grid__full" class:is-open={isOpen}>
	<h2>Definition</h2>
	<div class="ndefine">
		<slot />
	</div>
	<div class="more" on:click={() => (isOpen = !isOpen)}>
		Definitions can vary. Click to here for other definitions.
		<span class="darr">&dtrif;</span>
	</div>

	{#if isOpen}
		<div transition:slide class="grid--inner grid__full">
			{#each definitions as tab}
				<hr class="separator" />
				<blockquote class="definition">
					<strong class="definition-title">{tab.name}</strong>
					<div class="text">{tab.text}</div>
					<cite class="source"><a href={tab.source}>{tab.source}</a></cite>
				</blockquote>
			{/each}
		</div>
	{/if}
</div>

<style lang="scss">
	h2 {
		text-align: center;
		padding: 0;
		margin: 0;
	}
	.definitions {
		--container-bg: var(--bgc-accent-higher);
		@include svg-border-top(var(--container-bg), 24px);
		@include svg-border-bottom(var(--container-bg), 24px);
	}

	.ndefine {
		font-size: 1.25rem;
		font-weight: 500;
		opacity: 0.9;
		padding: 80px 0;
	}

	.more {
		font-size: 0.8rem;
		text-align: center;
		margin-bottom: 20px;
		color: var(--text-accent-high);
		cursor: pointer;
		&:hover {
			text-decoration: underline;
		}
	}
	.alternatives {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 10px;
	}
	.darr {
		text-align: center;
		font-weight: 600;
		font-size: 1.1rem;
	}

	.separator {
		border: none;
		border-top: dashed 2px var(--bgc-accent-high);
		grid-column: full;
		margin-top: 3vh;
		margin-bottom: 3vh;
	}

	.definition {
		padding: 40px 0;
		margin: 0;
		width: 100%;
		max-width: 100%;
	}

	.definition-title {
		display: block;
		text-transform: uppercase;
		letter-spacing: 1px;
		color: var(--text-accent);
		font-family: var(--font-heading);
		font-weight: 300;
		margin-bottom: 0.8em;
		font-size: 1.15rem;
	}

	.source {
		display: block;
		text-align: right;
		font-size: 0.7rem;
		font-style: normal;
		margin-top: 20px;

		a {
			color: var(--text-color);
			text-decoration: none;
			padding-bottom: 2px;
			font-weight: 500;
			&:hover {
				color: var(--link);
			}
		}
	}
</style>
